// Replace only the owned rating/count nodes; never reserialize staff HTML or signatures.
const countNode = /(<span\b(?=[^>]*\bdata-puresouls-review-count=["']true["'])[^>]*>)([^<]*)(<\/span>)/i;
const prefixNode = /(<span\b(?=[^>]*\bdata-puresouls-review-rating-prefix=["']true["'])[^>]*>)([^<]*)(<\/span>)/i;
const starsNode = /(<p\b(?=[^>]*\bdata-testid=["']review-email-rating-stars["'])[^>]*>)([^<]*)(<\/p>)/i;

export const validReviewCount = value => /^\d+$/.test(String(value)) && Number(value) <= 9999999;

export const readReviewCount = body => {
  if ((body?.match(/data-puresouls-review-count=["']true["']/g) || []).length !== 1) return null;
  const value = body.match(countNode)?.[2].match(/^([\d,]+) reviews? on Google$/)?.[1].replace(/,/g, '');
  return value !== undefined && validReviewCount(value) ? Number(value) : null;
};

export const updateReviewCount = (body, count) => {
  if (!validReviewCount(count) || readReviewCount(body) === null || !prefixNode.test(body) || !starsNode.test(body)) return body;
  const number = Number(count);
  const label = number ? '5 out of 5 stars' : 'No Google reviews yet';
  return body
    .replace(countNode, (_, open, text, close) => `${open}${number.toLocaleString('en-AU')} ${number === 1 ? 'review' : 'reviews'} on Google${close}`)
    .replace(prefixNode, (_, open, text, close) => `${open}${number ? 'Rated 5/5 by our customers · ' : ''}${close}`)
    .replace(starsNode, (_, open, text, close) => `${open.replace(/aria-label=(["']).*?\1/, `aria-label="${label}"`)}${number ? '★★★★★' : '☆☆☆☆☆'}${close}`);
};